function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.902 0H77v76H.902z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.916 18.883c1.95-.716 5.665-1.113 11.148-1.19 5.526-.078 9.736.412 12.63 1.47a2.751 2.751 0 011.773 2.154l1.8 11.361a2.751 2.751 0 01-2.717 3.182H27.435a2.751 2.751 0 01-2.319-4.231l7.43-11.643a2.751 2.751 0 011.37-1.103z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.483 56.627l21.385.025c.103-5.463 4.604-9.86 10.14-9.86 5.544 0 10.05 4.41 10.14 9.884l5.77.007.485-5.258c-.917-.93-1.329-1.74-1.162-2.473.851-3.735 1.164-7.483.86-9.093-1.574-8.338-3.882-14.067-6.887-17.176-3.169-3.193-6.507-5.437-10.015-6.737-5.335-1.977-20.184-2.038-24.962-.052-.54.224-.949.403-1.311.573-.99.467-1.675.905-2.348 1.516-.937.85-1.893 2.07-3.59 4.545-.57.83-5.157 7.68-7.138 10.586-.782 1.147-.947 1.218-9.062 4.323-5.657 2.165-8.38 3.69-8.655 5.217-.281 1.556-.235 3.867.103 9.11a1.25 1.25 0 01-.014.283c-.03.186-.098.363-.202.565-.056.108-.317.56-.274.483-.257.455-.36.77-.342 1.17.021.433.092 1.212.211 2.33l6.59.008c.128-5.44 4.62-9.81 10.139-9.81 5.527 0 10.023 4.382 10.139 9.834zm-26.73-3.542a8.233 8.233 0 010 0zm32.706-33.863c1.922-.678 5.43-1.045 10.56-1.118 5.286-.075 9.32.4 12.111 1.433a3.251 3.251 0 012.033 2.29c.47 1.956.787 3.459.954 4.513.156.985.415 3.062.778 6.238a3.251 3.251 0 01-3.23 3.62H28.74a3.251 3.251 0 01-2.741-5l6.799-10.659a3.251 3.251 0 011.66-1.317z",
  stroke: "#371447",
  fill: "#64B5F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.14 51.699a7.417 7.417 0 00-1.252 4.131c0 4.144 3.392 7.503 7.575 7.503 4.184 0 7.576-3.359 7.576-7.503 0-1.684-.56-3.24-1.507-4.491m29.271.36a7.417 7.417 0 00-1.25 4.131c0 4.144 3.391 7.503 7.575 7.503 4.183 0 7.575-3.359 7.575-7.503 0-1.684-.56-3.24-1.507-4.491",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 18.463,
  cy: 55.83,
  rx: 3.788,
  ry: 3.751
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 60.128,
  cy: 55.83,
  rx: 3.788,
  ry: 3.751
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#371447",
  fill: "#64B5F6",
  x: 22.407,
  y: 32.508,
  width: 7.608,
  height: 4.798,
  rx: 2.399
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.339 44.968c.771.1 1.17.275 1.195.525.038.378.069 1.464.092 3.258-1.441.776-2.338 1.095-2.69.956m73.913-5.312c-1.235.092-2.029.085-2.382-.019-.153-.045-.216-1.26-.249-1.76-.028-.433.045-.77.218-1.01.288-.261.483-.39.585-.39.308.005.537.01.688.02",
  stroke: "#371447"
}));

function SvgVehiclesLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVehiclesLg;